import React, {useEffect, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {Button} from "primereact/button";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {Calendar} from "primereact/calendar";
import {setClearFilters} from "../../../../redux/actions/actions";
import {getStatusesByPeriodExcelByLink, generateStatusesByPeriodExcel, getFilesHistory, deleteAllFiles, deleteFileById} from "../../../../redux/api/apiStatusesByPeriodList";
import {setFilesCurrentPage, setFilesCurrentPageSize} from "../../../../redux/actions/actionsStatusesByPeriodList";
import {getUsers} from "../../../../redux/api/api";
import {SET_UPLOAD_FILE_STATUS_SUCCESS} from "../../../../redux/types/typesUsersList";
import {Dropdown} from "primereact/dropdown";
import {OverlayPanel} from "primereact/overlaypanel";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import {ConfirmDialog} from "primereact/confirmdialog";
import {GET_STATUSES_BY_PERIOD_LIST} from "../../../../redux/types/typesStatusesByPeriodList";

const StatusesByPeriodListNav = (props: any) => {
    const dispatch = useAppDispatch()
    const exportLoading = useAppSelector(state => state.StatusesByPeriodListReducer.exportLoading);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const user = useAppSelector(state => state.UsersReducer.userData);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const statisticPermissions = checkPermissions(rolesVision, 'Statistic');
    const statusesByPeriodList = useAppSelector(state => state.StatusesByPeriodListReducer?.statusesByPeriodList);
    const allSimpleUsers = useAppSelector((state: any) => state.CompaniesListReducer?.usersData);
    const [isListLength, setIsListLength] = useState(false);
    const excelToast = useRef<any>(null);
    const [first, setFirst] = useState(0);
    const filesPaginationSize = useAppSelector(state => state.StatusesByPeriodListReducer.filesPaginationSize);
    const filesPagination = useAppSelector(state => state.StatusesByPeriodListReducer.filesPagination);
    const filesPaginationPage = useAppSelector(state => state.StatusesByPeriodListReducer.filesPaginationPage);
    const [filesTotalItems, setFilesTotalItems] = useState<number>(filesPaginationSize);
    const [filesHistoryItems, setFilesHistoryItems] = useState<any>([]);
    const [newFileNotify, setNewFileNotify] = useState<boolean>(false);
    const [visibleDeleteAllFilesMessage, setVisibleDeleteAllFilesMessage] = useState(false);
    const [visible, setVisible] = useState(false);
    const [currentId, setCurrentId] = useState<any>(null);
    const [isFilesPanelVisible, setIsFilesPanelVisible] = useState(false);
    const previousLengthRef = useRef<number | null>(null);
    const filesHistory = useAppSelector(state => state.StatusesByPeriodListReducer?.filesHistory);
    const filesHistoryLoader = useAppSelector(state => state.StatusesByPeriodListReducer?.filesHistoryLoader);

    const minDate = new Date(2023, 5, 1);   // 01.06.2023  (месяцы с 0)

    const getDefaultStartTime = () => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    };

    const getDefaultEndTime = () => {
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        return d;
    };

    const getDefaultStartDate = () => {
        return new Date();
    };

    const getDefaultEndDate = () => {
        return new Date();
    };

    useEffect(() => {
        setIsListLength(!!statusesByPeriodList?.length);
    }, [statusesByPeriodList]);

    useEffect(() => {
        const currentLength = filesHistory?.length || 0;
        const prevLength = previousLengthRef.current;

        if (prevLength !== null && currentLength > prevLength) {
            setNewFileNotify(true);
        }

        previousLengthRef.current = currentLength;
        setFilesHistoryItems(filesHistory);
    }, [filesHistory]);

    useEffect(() => {
        dispatch(getUsers(jwtToken?.jwtToken));
    }, []);

    useEffect(() => {
        if (filesPagination.hasNext && filesPagination.pageNumber) {
            setFilesTotalItems((filesPagination.pageNumber * filesPaginationSize) + filesPaginationSize)
        } else if (!filesPagination.hasNext) {
            setFilesTotalItems(filesPagination.pageNumber * filesPaginationSize);
        }
    }, [filesPagination]);

    useEffect(() => {
        setFilesTotalItems((filesPagination.pageNumber * filesPaginationSize) + filesPaginationSize);
    }, [])

    const handleUpload = (id: number) => {
        dispatch(getStatusesByPeriodExcelByLink(id, jwtToken?.jwtToken));
    }

    const uploadByUrl = (fileUrl: any, fileName: any) => {
        if (fileUrl) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }

    const handleDeleteFile = (id: number) => {
        dispatch(deleteFileById(id, {
            pageNumber: filesPaginationPage,
            pageSize: filesPaginationSize,
        }, jwtToken?.jwtToken));
    };

    const acceptDeleteFile = () => {
        handleDeleteFile(currentId);
        setVisible(false);
    };

    const reject = () => {
        setVisible(false);
    };

    const bodyExcelUpload = (rowData: any) => {
        return <div className="flex justify-content-center">
            {!rowData?.tempUrl ? <Button onClick={() => handleUpload(rowData?.id)} icon="pi pi-download" className="p-button-secondary ml-auto mr-2"></Button> :
                <Button icon="pi pi-download" className="p-button-secondary ml-auto mr-2" onClick={() => uploadByUrl(rowData?.tempUrl, rowData?.fileName)}/>}
            <Button onClick={() => {
                setCurrentId(rowData?.id);
                setVisible(true);
            }} icon="pi pi-trash" className="p-button-secondary mx-auto"></Button>
        </div>
    }

    const bodyExcelId = (rowData: any) => {
        return <div className="flex justify-content-center">
            {rowData?.id || <i className="pi pi-plus"></i>}
        </div>
    }

    const onPageChange = (event: { first: React.SetStateAction<number>; page: number; rows: any; }) => {
        setFirst(event.first);
        dispatch(setFilesCurrentPage(event.page + 1));
        dispatch(setFilesCurrentPageSize(event.rows));
        dispatch(getFilesHistory({
            pageNumber: event.page + 1,
            pageSize: event.rows,
        }, jwtToken?.jwtToken));
    }

    const {
        update: hasUpdatePermission,
    } = statisticPermissions;

    let filteredObject = {
        "sort": props.sortData?.sort,
        "filter": props.sortData?.filter,
        "username": user?.userName
    };

    const isDisabled = () => {
        return !props.endTime || !props.startTime || !props.filterDateTime || !props.filterEndDateTime || !props.selectedUser;
    };

    const usersDataWithFullName = allSimpleUsers?.map((userData: any) => {
        return {
            ...userData,
            fullName: `${userData?.lastName} ${userData?.firstName} ${userData?.middleName ? ` ${userData.middleName}` : ''}`
        }
    });

    return (
        <>
            <div className="table-buttons">
                <div className="text-normal-weight flex align-items-center">
                    <div className="desktop">
                        <div className="flex field align-items-center">
                            <Dropdown
                                value={props.selectedUser}
                                options={usersDataWithFullName}
                                onChange={(e) => props.setSelectedUser(e.value)}
                                optionValue="userName"
                                placeholder="Оберіть оператора:"
                                className="mt-2 mr-2"
                                style={{minWidth: '250px'}}
                                filter
                                optionLabel="fullName"
                                scrollHeight="250px"
                            />
                        </div>
                    </div>
                    <div className="flex field align-items-center max-w-15rem ml-4 desktop-filter">
                        <span className="title pt-2" style={{width: '35px'}}>З*</span>
                        <Calendar disabled={props.allTimeChecked} className="mt-2" value={props.filterDateTime ? props.filterDateTime : null} onChange={(e: any) => {
                            props.setFilterDateTime(e.value)
                        }} onInput={(e: any) => {
                            const input = e.target as HTMLInputElement;

                            const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                            const dd = digits.slice(0, 2);
                            const mm = digits.slice(2, 4);
                            const yyyy = digits.slice(4, 8);

                            const display =
                                (dd || "") +
                                (digits.length > 2 ? "/" + mm : "") +
                                (digits.length > 4 ? "/" + yyyy : "");

                            const newCaret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);

                            if (input.value !== display) {
                                input.value = display;
                                input.setSelectionRange(newCaret, newCaret);
                            }

                            if (digits.length === 8) {
                                const day = parseInt(dd, 10);
                                const month = parseInt(mm, 10) - 1; // 0-based
                                const year = parseInt(yyyy, 10);
                                const parsed = new Date(year, month, day);

                                const valid =
                                    !isNaN(parsed.getTime()) &&
                                    parsed.getDate() === day &&
                                    parsed.getMonth() === month &&
                                    parsed.getFullYear() === year &&
                                    parsed >= minDate;

                                props.setFilterDateTime(valid ? parsed : null);
                            }
                        }} onFocus={(e: any) => {
                            if (props.filterDateTime) {
                                props.setFilterDateTime(null);
                            }
                        }} onBlur={(e: any) => {
                            const digits = e.target.value.replace(/\D/g, "");
                            if (digits.length !== 8) {
                                e.target.value = "";
                                props.setFilterDateTime(null);
                            }
                            if (!props.filterDateTime) {
                                props.setFilterDateTime(getDefaultStartDate());
                            }
                        }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                                  maxDate={new Date()}
                                  dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
                        <Calendar
                            key={`start-time-${props.allTimeChecked}`}
                            appendTo="self"
                            id="icon"
                            className="mt-2 ml-2"
                            placeholder="00:00"
                            value={props.startTime ? props.startTime : null}
                            timeOnly
                            hourFormat="24"
                            disabled={props.allTimeChecked}
                            onChange={(e) => {
                                if (e.value) props.setStartTime(e.value);
                            }}
                            onFocus={() => {
                                props.setStartTime(null);
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = props.startTime ? new Date(props.startTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        props.setStartTime(base);
                                    }
                                }
                            }}
                            onBlur={() => {
                                if (!props.startTime) {
                                    props.setStartTime(getDefaultStartTime());
                                }
                            }}
                        />
                    </div>
                    <div className="flex field align-items-center max-w-15rem ml-2 desktop-filter">
                        <span className="title pt-2" style={{width: '35px'}}>По*</span>
                        <Calendar className="mt-2" disabled={props.allTimeChecked} value={props.filterEndDateTime ? props.filterEndDateTime : null} onChange={(e: any) => {
                            props.setFilterEndDateTime(e.value)
                        }} onInput={(e: any) => {
                            const input = e.target as HTMLInputElement;

                            const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                            const dd = digits.slice(0, 2);
                            const mm = digits.slice(2, 4);
                            const yyyy = digits.slice(4, 8);

                            const display =
                                (dd || "") +
                                (digits.length > 2 ? "/" + mm : "") +
                                (digits.length > 4 ? "/" + yyyy : "");

                            const newCaret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);

                            if (input.value !== display) {
                                input.value = display;
                                input.setSelectionRange(newCaret, newCaret);
                            }

                            if (digits.length === 8) {
                                const day = parseInt(dd, 10);
                                const month = parseInt(mm, 10) - 1; // 0-based
                                const year = parseInt(yyyy, 10);
                                const parsed = new Date(year, month, day);

                                const valid =
                                    !isNaN(parsed.getTime()) &&
                                    parsed.getDate() === day &&
                                    parsed.getMonth() === month &&
                                    parsed.getFullYear() === year &&
                                    parsed >= minDate;

                                props.setFilterEndDateTime(valid ? parsed : null);
                            }
                        }} onFocus={(e: any) => {
                            if (props.filterEndDateTime) {
                                props.setFilterEndDateTime(null);
                            }
                        }} onBlur={(e: any) => {
                            const digits = e.target.value.replace(/\D/g, "");
                            if (digits.length !== 8) {
                                e.target.value = "";
                                props.setFilterEndDateTime(null);
                            }
                            if (!props.filterEndDateTime) {
                                props.setFilterEndDateTime(getDefaultEndDate());
                            }
                        }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                                  maxDate={new Date()}
                                  dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            className="mt-2 ml-2"
                            placeholder="00:00"
                            value={props.endTime ? props.endTime : null}
                            timeOnly
                            hourFormat="24"
                            disabled={props.allTimeChecked}
                            onChange={(e) => {
                                if (e.value) props.setEndTime(e.value);
                            }}
                            onFocus={() => {
                                props.setEndTime(null);
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = props.endTime ? new Date(props.endTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        props.setEndTime(base);
                                    }
                                }
                            }}
                            onBlur={() => {
                                if (!props.endTime) {
                                    props.setEndTime(getDefaultEndTime());
                                }
                            }}
                        />
                    </div>
                    <Button disabled={isDisabled()} onClick={() => {
                        props.setHasStartFilter(true);
                        if (props.allTimeChecked === null) {
                            props.setAllTimeChecked(false)
                        }
                    }}
                            icon="pi pi-search" className="mb-2 ml-2 desktop-filter"/>
                </div>
                <div className="desktop">
                    <div className="flex align-items-center">
                        {hasUpdatePermission &&
                            <div className="flex">
                                <div className="">
                                    <Button style={{backgroundColor: '#1d6f42'}} className={`p-button-success mr-2 mb-2 text-white ${newFileNotify ? 'animate-bounce-loop' : 'shadow-none'}`} type="button" icon="pi pi-download"
                                            onClick={(e) => {
                                                if (!isFilesPanelVisible) {
                                                    dispatch(getFilesHistory({
                                                        pageNumber: filesPaginationPage,
                                                        pageSize: filesPaginationSize,
                                                    }, jwtToken?.jwtToken));
                                                    dispatch({type: SET_UPLOAD_FILE_STATUS_SUCCESS, payload: null});
                                                    setNewFileNotify(false);
                                                }
                                                setIsFilesPanelVisible(true);
                                                excelToast.current.toggle(e);
                                            }}
                                    />
                                    <ConfirmDialog style={{zIndex: 9999999999999}} visible={visible} onHide={() => setVisible(false)} message="Файл буде видалено зі списку, продовжити ?"
                                               header="Попередження" acceptLabel="Так" rejectLabel="Ні" icon="pi pi-exclamation-triangle" accept={() => acceptDeleteFile()} reject={reject}/>
                                    <ConfirmDialog visible={visibleDeleteAllFilesMessage} style={{zIndex: 99999999999999}} onHide={() => setVisibleDeleteAllFilesMessage(false)} message="Всі файли будуть видалені, продовжити ?"
                                               header="Попередження" acceptLabel="Так" rejectLabel="Ні" icon="pi pi-exclamation-triangle" accept={() => {
                                            setVisibleDeleteAllFilesMessage(false);
                                            dispatch(deleteAllFiles(jwtToken?.jwtToken));
                                            excelToast.current.hide();
                                        }} reject={() => setVisibleDeleteAllFilesMessage(false)}/>
                                    <OverlayPanel className="excelPanel" ref={excelToast} style={{minWidth: '38rem'}} onHide={() => setIsFilesPanelVisible(false)}>
                                        <div className="flex justify-content-end align-items-center">
                                            <Button type="button" disabled={filesHistory?.length < 1} label="Видалити все" icon="pi pi-trash" className="p-button-outlined mr-4"
                                                    onClick={() => {
                                                        excelToast.current.hide();
                                                        setVisibleDeleteAllFilesMessage(true);
                                                    }}/>
                                            <Button onClick={() => {
                                                excelToast.current.hide();
                                                setNewFileNotify(false);
                                            }} icon="pi pi-times" className="p-button-secondary"></Button>
                                        </div>
                                        <DataTable loading={filesHistoryLoader} emptyMessage="Файлів поки немає" style={{minWidth: '300px'}} value={filesHistoryItems}>
                                            <Column field="id" header="ID" body={bodyExcelId}></Column>
                                            <Column field="fileName" header="Назва"></Column>
                                            <Column field="code" header="Дія" style={{maxWidth: '100px'}} body={bodyExcelUpload}></Column>
                                        </DataTable>
                                        <Paginator
                                            first={first}
                                            rows={filesPaginationSize}
                                            totalRecords={filesTotalItems}
                                            rowsPerPageOptions={[5, 10, 15, 25, 50]}
                                            onPageChange={onPageChange}
                                            className="border-top-1 border-bottom-1"
                                            template="PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
                                        />
                                    </OverlayPanel>
                                </div>
                            </div>}
                        {hasUpdatePermission &&
                            <Button onClick={() => dispatch(generateStatusesByPeriodExcel(filteredObject, jwtToken?.jwtToken))}
                                    label="Сформувати таблицю"
                                    loading={exportLoading}
                                    disabled={!isListLength}
                                    icon="pi pi-file-excel"
                                    style={{backgroundColor: '#1d6f42'}}
                                    className="mr-2 mb-2 p-button-success text-white shadow-none"
                            />}
                        <Button type="button" icon="pi pi-filter-slash" label="Очистити фільтри"
                                className="p-button-outlined mr-2 mb-2" onClick={() => {
                            props.resetSorting();
                            dispatch({type: GET_STATUSES_BY_PERIOD_LIST, payload: null});
                            props.setActivity(false);
                            props.setSelectedUser(null);
                        }}/>
                    </div>
                </div>
                <div className="mobile w-full">
                    <div className="flex justify-content-between">
                        <div className="flex w-full justify-content-between">
                            <div className="col-12 field align-items-center sm:justify-content-between mobile-filter px-0">
                                <Dropdown
                                    value={props.selectedUser}
                                    options={usersDataWithFullName}
                                    onChange={(e) => props.setSelectedUser(e.value)}
                                    optionValue="userName"
                                    placeholder="Оберіть оператора:"
                                    className="mt-2 w-full mr-4"
                                    style={{maxWidth: '250px'}}
                                    filter
                                    optionLabel="fullName"
                                    scrollHeight="250px"
                                />
                                <div className="flex">
                                    {hasUpdatePermission && <Button style={{backgroundColor: '#1d6f42'}} className={`p-button-success mr-2 text-white ${newFileNotify ? 'animate-bounce-loop' : 'shadow-none'}`} type="button" icon="pi pi-download"
                                            onClick={(e) => {
                                                if (!isFilesPanelVisible) {
                                                    dispatch(getFilesHistory({
                                                        pageNumber: filesPaginationPage,
                                                        pageSize: filesPaginationSize,
                                                    }, jwtToken?.jwtToken));
                                                    dispatch({type: SET_UPLOAD_FILE_STATUS_SUCCESS, payload: null});
                                                    setNewFileNotify(false);
                                                }
                                                setIsFilesPanelVisible(true);
                                                excelToast.current.toggle(e);
                                            }}
                                    />}
                                    {hasUpdatePermission && <Button onClick={() => dispatch(generateStatusesByPeriodExcel(filteredObject, jwtToken?.jwtToken))}
                                            icon="pi pi-file-excel"
                                            disabled={!isListLength}
                                            loading={exportLoading}
                                            style={{backgroundColor: '#1d6f42'}}
                                            className="mr-2 p-button-success text-white shadow-none"
                                    />}
                                    <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined"
                                            onClick={() => dispatch(setClearFilters())}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex align-items-center flex-wrap justify-content-between">
                <div className="col-12 md:col-5 sm:col-5 field align-items-center mobile-filter mb-0 px-0">
                    <span className="title pt-2" style={{minWidth: '35px'}}>З*</span>
                    <Calendar className="mt-2 w-full"
                              style={{maxWidth: '200px'}}
                              disabled={props.allTimeChecked} value={props.filterDateTime ? props.filterDateTime : null} onChange={(e: any) => {
                        props.setFilterDateTime(e.value)
                    }} onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                        const dd = digits.slice(0, 2);
                        const mm = digits.slice(2, 4);
                        const yyyy = digits.slice(4, 8);

                        const display =
                            (dd || "") +
                            (digits.length > 2 ? "/" + mm : "") +
                            (digits.length > 4 ? "/" + yyyy : "");

                        const newCaret =
                            digits.length +
                            (digits.length > 2 ? 1 : 0) +
                            (digits.length > 4 ? 1 : 0);

                        if (input.value !== display) {
                            input.value = display;
                            input.setSelectionRange(newCaret, newCaret);
                        }

                        if (digits.length === 8) {
                            const day = parseInt(dd, 10);
                            const month = parseInt(mm, 10) - 1; // 0-based
                            const year = parseInt(yyyy, 10);
                            const parsed = new Date(year, month, day);

                            const valid =
                                !isNaN(parsed.getTime()) &&
                                parsed.getDate() === day &&
                                parsed.getMonth() === month &&
                                parsed.getFullYear() === year &&
                                parsed >= minDate;

                            props.setFilterDateTime(valid ? parsed : null);
                        }
                    }} onFocus={(e: any) => {
                        if (props.filterDateTime) {
                            props.setFilterDateTime(null);
                        }
                    }} onBlur={(e: any) => {
                        const digits = e.target.value.replace(/\D/g, "");
                        if (digits.length !== 8) {
                            e.target.value = "";
                            props.setFilterDateTime(null);
                        }
                        if (!props.filterDateTime) {
                            props.setFilterDateTime(getDefaultStartDate());
                        }
                    }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                              maxDate={new Date()}
                              dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
                    <Calendar
                        key={`start-time-mobile-${props.allTimeChecked}`}
                        appendTo="self"
                        id="icon"
                        style={{maxWidth: '200px'}}
                        className="mt-2 ml-2 w-full mr-2"
                        placeholder="00:00"
                        disabled={props.allTimeChecked}
                        value={props.startTime ? props.startTime : null}
                        timeOnly
                        hourFormat="24"
                        onChange={(e) => {
                            if (e.value) props.setStartTime(e.value);
                        }}
                        onFocus={() => {
                            props.setStartTime(null);
                        }}
                        onInput={(e: any) => {
                            const input = e.target as HTMLInputElement;

                            let digits = input.value.replace(/\D/g, "").slice(0, 4);
                            const HH = digits.slice(0, 2);
                            const MM = digits.slice(2, 4);

                            const display = HH + (digits.length > 2 ? ":" + MM : "");

                            if (input.value !== display) {
                                const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                input.value = display;
                                input.setSelectionRange(caret, caret);
                            }

                            if (digits.length === 4) {
                                const h = parseInt(HH, 10);
                                const m = parseInt(MM, 10);
                                const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                if (valid) {
                                    const base = props.startTime ? new Date(props.startTime) : new Date();
                                    base.setHours(h, m, 0, 0);
                                    props.setStartTime(base);
                                }
                            }
                        }}
                        onBlur={() => {
                            if (!props.startTime) {
                                props.setStartTime(getDefaultStartTime());
                            }
                        }}
                    />
                </div>
                <div className="col-12 md:col-5 sm:col-5 field align-items-center mobile-filter mb-0 px-0">
                    <span className="title pt-2" style={{minWidth: '35px'}}>По*</span>
                    <Calendar
                        style={{maxWidth: '200px'}}
                        className="mt-2 w-full" disabled={props.allTimeChecked} value={props.filterEndDateTime ? props.filterEndDateTime : null} onChange={(e: any) => {
                        props.setFilterEndDateTime(e.value)
                    }} onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                        const dd = digits.slice(0, 2);
                        const mm = digits.slice(2, 4);
                        const yyyy = digits.slice(4, 8);

                        const display =
                            (dd || "") +
                            (digits.length > 2 ? "/" + mm : "") +
                            (digits.length > 4 ? "/" + yyyy : "");

                        const newCaret =
                            digits.length +
                            (digits.length > 2 ? 1 : 0) +
                            (digits.length > 4 ? 1 : 0);

                        if (input.value !== display) {
                            input.value = display;
                            input.setSelectionRange(newCaret, newCaret);
                        }

                        if (digits.length === 8) {
                            const day = parseInt(dd, 10);
                            const month = parseInt(mm, 10) - 1; // 0-based
                            const year = parseInt(yyyy, 10);
                            const parsed = new Date(year, month, day);

                            const valid =
                                !isNaN(parsed.getTime()) &&
                                parsed.getDate() === day &&
                                parsed.getMonth() === month &&
                                parsed.getFullYear() === year &&
                                parsed >= minDate;

                            props.setFilterEndDateTime(valid ? parsed : null);
                        }
                    }} onFocus={(e: any) => {
                        if (props.filterEndDateTime) {
                            props.setFilterEndDateTime(null);
                        }
                    }} onBlur={(e: any) => {
                        const digits = e.target.value.replace(/\D/g, "");
                        if (digits.length !== 8) {
                            e.target.value = "";
                            props.setFilterEndDateTime(null);
                        }
                        if (!props.filterEndDateTime) {
                            props.setFilterEndDateTime(getDefaultEndDate());
                        }
                    }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                        maxDate={new Date()}
                        dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
                    <Calendar
                        key={`end-time-mobile-${props.allTimeChecked}`}
                        appendTo="self"
                        id="icon"
                        className="mt-2 ml-2 w-full mr-2"
                        placeholder="00:00"
                        style={{maxWidth: '200px'}}
                        disabled={props.allTimeChecked}
                        value={props.endTime ? props.endTime : null}
                        timeOnly
                        hourFormat="24"
                        onChange={(e) => {
                            if (e.value) props.setEndTime(e.value);
                        }}
                        onFocus={() => {
                            props.setEndTime(null);
                        }}
                        onInput={(e: any) => {
                            const input = e.target as HTMLInputElement;

                            let digits = input.value.replace(/\D/g, "").slice(0, 4);
                            const HH = digits.slice(0, 2);
                            const MM = digits.slice(2, 4);

                            const display = HH + (digits.length > 2 ? ":" + MM : "");

                            if (input.value !== display) {
                                const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                input.value = display;
                                input.setSelectionRange(caret, caret);
                            }

                            if (digits.length === 4) {
                                const h = parseInt(HH, 10);
                                const m = parseInt(MM, 10);
                                const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                if (valid) {
                                    const base = props.endTime ? new Date(props.endTime) : new Date();
                                    base.setHours(h, m, 0, 0);
                                    props.setEndTime(base);
                                }
                            }
                        }}
                        onBlur={() => {
                            if (!props.endTime) {
                                props.setEndTime(getDefaultEndTime());
                            }
                        }}
                    />
                </div>
                <div className="col-12 md:col-2 sm:col-2 sm:mb-0 p-0 justify-content-start flex sm:justify-content-center align-items-center md:justify-content-end">
                    <Button onClick={() => {
                        props.setHasStartFilter(true);
                        if (props.allTimeChecked === null) {
                            props.setAllTimeChecked(false)
                        }
                    }}
                            disabled={isDisabled()}
                            icon="pi pi-search" label="Пошук" className="mobile-filter mobile-filter-btn mt-1"
                            style={{minWidth: '30px'}}/>
                </div>
            </div>
        </>
    )
}

export default StatusesByPeriodListNav;
